module.exports = __webpack_public_path__ + "static/media/Condo_Hotel_Financing.03590030.png";